export default __webpack_public_path__ + "static/media/eyitayo_hero.b9be24eb.webp";